let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("026Z8")).then(() => parcelRequire('lR0RM'));